exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-comment-form[data-v-5e85ec3e]{padding-bottom:13px;margin-bottom:32px}", ""]);

// exports
